// should move to dynamic data instead
import TGSNftWL from './TGS.json';

const META_DATA = {
  [process.env.REACT_APP_NFT_DROP_ADDRESS || '']: TGSNftWL,
};

export const getNftWhitelist = (collection: string) => META_DATA[collection] ?? TGSNftWL;
